export type NetworksRouteType = 'customer' | 'zencargo';

export interface NetworksRoutes {
  location: {
    edit: {
      getUrl: (organisationId: string, locationId: string) => string;
      path: string;
      relativePath: string;
    };
  };
  myOrganisation: {
    index: {
      getUrl: () => string;
      path: string;
      relativePath: string;
    };
  };
}

const networks = (type: NetworksRouteType = 'customer'): NetworksRoutes => {
  const networksRelativePath = type === 'customer' ? 'networks' : 'zencargo-network';
  const networksRootPath = `/dashboard/${networksRelativePath}`;

  return {
    location: {
      edit: {
        path: `${networksRootPath}/organisations/:organisationId/locations/:locationId/edit`,
        relativePath: 'organisations/:organisationId/locations/:locationId/edit',
        getUrl: (organisationId: string, locationId: string) =>
          `${networksRootPath}/organisations/${organisationId}/locations/${locationId}/edit`
      }
    },
    myOrganisation: {
      index: {
        path: `${networksRootPath}/*`,
        relativePath: `${networksRelativePath}/*`,
        getUrl: () => networksRootPath
      }
    }
  };
};

export default networks;
